<template>
  <Modal v-if="showModalAssign" @close="closeModalAssign">
    <div class="assignDelivery">
      <div class="assignDelivery__header">
        <span class="title">
          {{
            $t(isAPIReservations ? 'assignDeliveryFromDesk' : 'updateDelivery')
          }}
        </span>
        <img
          src="@/assets/icons/CloseModal.svg"
          alt=""
          @click="closeModalAssign"
        />
      </div>
      <Toggle
        :title="$t('chooseSeveralShelves')"
        :value="multipleShelves"
        name="multipleShelves"
        @change="multipleShelves = !multipleShelves"
      />
      <FormKit
        type="form"
        id="assignDelivery-form"
        v-model="formData"
        :actions="false"
        @submit="submitHandler"
      >
        <Dropdown
          :class="{
            'chooseShelf-dropdown': true,
            'chooseShelf-dropdown-error':
              isError && chooseShelf.selectedOption.length === 0
          }"
          :selectedOption="chooseShelf.selectedOption"
          :options="chooseShelf.options"
          :label="$t('chooseShelf')"
          :multiple="getMultipleDropdown()"
          @selectOption="selectShelves"
        />
        <div class="assignDelivery__description" v-if="isAPIReservations">
          <label class="label-description" :for="formData.description">
            {{ $t('description') }}
          </label>
          <textarea
            v-model="formData.description"
            id="description"
            class="input-description"
            maxlength="250"
          >
          </textarea>
        </div>
        <div
          class="assignDelivery__isError"
          v-if="
            isAPIReservations &&
            isError &&
            chooseShelf.selectedOption.length === 0
          "
        >
          <p>{{ $t('validation.required') }}</p>
        </div>
      </FormKit>
      <div class="assignDelivery__button">
        <Button variant="filled" :title="$t('save')" @click="submitForm" />
      </div>
      <div class="assignDelivery__body" v-if="isAPIReservations">
        <span class="title">{{ $t('assignDeliveryFromLocker') }}</span>
        <span class="warning">{{ $t('assignToLocker') }}</span>
      </div>
      <div class="assignDelivery__buttons" v-if="isAPIReservations">
        <Button
          class="assignDelivery__buttons-redirect"
          variant="filled"
          :title="$t('redirectToPickupBox')"
          @click="redirectToPickupBox"
        />
        <Button
          variant="redBordered"
          :title="$t('cancel')"
          @click="closeModalAssign"
        />
      </div>
    </div>
  </Modal>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { mapState } from 'vuex';

import router from '@/router';

import { Option } from '@/types';
import { Shelf } from '@/store/modules/pharmacy/types';

@Options({
  name: 'AssignDelivery',
  props: ['showModalAssign', 'activeReservations'],
  data() {
    return {
      formData: {
        description: '',
        shelf: ''
      },
      boxId: '',
      chooseShelf: {
        selectedOption: [],
        options: []
      },
      isError: false,
      multipleShelves: false
    };
  },
  computed: {
    ...mapState('pharmacy', ['pharmacy']),
    isAPIReservations() {
      return this.$route.name === 'APIReservations';
    }
  },
  created() {
    if (this.pharmacy?.shelves) {
      this.initShelves();

      if (!this.isAPIReservations) {
        this.initActiveShelf();
      }
    }
  },
  methods: {
    async closeModalAssign() {
      this.$emit('closeModal');

      await this.$emit('loadPickupBoxes');
    },
    getShelvesName(name: string) {
      return name === 'cooling'
        ? this.$t('cooling')
        : name.substring(0, 3).toUpperCase() + name.substring(3);
    },
    getMultipleDropdown() {
      return this.multipleShelves ? true : false;
    },
    initShelves() {
      const shelves = this.pharmacy?.shelves.map((shelf: Shelf) => ({
        label: this.getShelvesName(shelf.name),
        value: shelf.name,
        numberOfReservations: shelf.numberOfReservations
      }));

      this.chooseShelf.options = shelves;
    },
    initActiveShelf() {
      this.shelf = this.activeReservations?.shelf;

      if (this.activeReservations?.shelf) {
        const activeShelf = this.chooseShelf.options.filter((option: Option) =>
          this.shelf.includes(option.value)
        );

        if (activeShelf.length) {
          this.multipleShelves = true;
        } else {
          this.multipleShelves = false;
        }

        if (!this.isAPIReservations) {
          if (activeShelf.length > 1) {
            this.multipleShelves = true;
          } else {
            this.multipleShelves = false;
          }
        }

        this.chooseShelf.selectedOption = [...activeShelf];
      }
    },
    selectShelves(option: Option) {
      this.chooseShelf.selectedOption = option;

      if (this.multipleShelves) {
        this.formData.shelf = this.chooseShelf.selectedOption.map(
          (item: Option) => item.value
        );
      } else {
        this.formData.shelf = [this.chooseShelf.selectedOption].map(
          (item: Option) => item.value
        );
      }
    },
    redirectToPickupBox() {
      const { id } = this.$route.params;
      this.boxId = this.pharmacy?.pickupBoxes[0];

      router.push({ name: 'Lockers', params: { id, boxId: this.boxId } });
    },
    submitHandler() {
      if (this.formData.shelf) {
        this.$emit(
          'assignDeliveryRequest',
          this.activeReservations.deliveryId,
          this.formData.description,
          this.formData.shelf
        );
      } else {
        this.isError = true;
      }
    },
    submitForm() {
      this.$formkit.submit('assignDelivery-form');
    }
  },
  watch: {
    pharmacy() {
      if (this.pharmacy?.shelves) {
        this.initShelves();
        if (!this.isAPIReservations) {
          this.initActiveShelf();
        }
      }
    },
    activeReservations() {
      if (this.activeReservations.shelf) {
        if (!this.isAPIReservations) {
          this.initActiveShelf();
        }
      }
    },
    showModalAssign() {
      if (!this.showModalAssign) {
        this.multipleShelves = false;
        this.chooseShelf.selectedOption = [];
      }
    },
    multipleShelves() {
      if (this.multipleShelves) {
        this.chooseShelf.selectedOption = [];
      } else {
        this.chooseShelf.selectedOption = [];
      }
    }
  }
})
export default class AssignDelivery extends Vue {}
</script>

<style lang="scss">
.assignDelivery {
  width: 400px;
  height: 100%;
  padding: 24px;
  .assignDelivery__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
    .title {
      font-family: 'Ubuntu-Medium';
      font-size: $eighteenSize;
      line-height: $fifteenSize;
    }
    img {
      cursor: pointer;
    }
  }
  .toggle {
    justify-content: flex-end !important;
    margin-bottom: 24px;
  }
  .formkit-form {
    .chooseShelf-dropdown {
      width: 400px;
      height: 48px;
      margin-bottom: 30px;
      &.chooseShelf-dropdown-error {
        .dropdown__head {
          border-color: $messageError;
        }
      }
    }
  }
  .assignDelivery__description {
    position: relative;
    margin-bottom: 24px;
    label {
      position: absolute;
      font-family: 'Ubuntu-Regular';
      top: -6px;
      left: 15px;
      padding: 0 5px;
      background: $white;
      color: $label;
      font-weight: 400;
      font-size: $twelveSize;
      line-height: $fourteenSize;
      z-index: 1;
    }
    textarea {
      width: 366px;
      height: 100px;
      padding: 16px;
      font-size: $fourteenSize;
      border: 1px solid $border;
      border-radius: 8px;
      resize: none;
      &:focus {
        outline: none;
      }
    }
  }
  .assignDelivery__isError {
    p {
      color: $messageError;
      font-size: $twelveSize;
      padding-bottom: 12px;
    }
  }
  .assignDelivery__body {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    margin: 24px 0;
    .title {
      font-family: 'Ubuntu-Medium';
      font-size: $sixteenSize;
      line-height: $fifteenSize;
      margin: 23px 0;
    }
    .warning {
      color: $label;
      font-size: $fourteenSize;
      line-height: $twentyTwoSize;
      font-weight: 500;
    }
  }
  .assignDelivery__buttons {
    .assignDelivery__buttons-redirect {
      width: 190px;
      margin-right: 12px;
    }
  }
}
</style>
